export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

export const PACKAGE_TYPES = {
  TRIAL: 'trial',
  BASE: 'base',
  BASIC_PLUS: 'basic_plus'
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  EXPIRED: 'expired'
};

export const TRANSACTION_TYPES = {
  DEBT: 'debt',
  PAYMENT: 'payment'
};

export const PAYMENT_METHODS = {
  CASH: 'cash',
  BENEFIT_CARD: 'benefit_card',
  NA: 'n/a'
};

export const DEBTOR_STATUS = {
  ACTIVE: 'active',
  CLEARED: 'cleared',
  ARCHIVED: 'archived'
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  DEBTORS: '/debtors',
  DEBTOR_DETAIL: '/debtors/:id',
  SETTINGS: '/settings',
  SELECT_PACKAGE: '/select-package',
  SUBSCRIPTION_EXPIRED: '/subscription-expired',
  ADMIN_LOGIN: '/admin/login',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_MERCHANTS: '/admin/merchants'
};

export const COLORS = {
  OUTSTANDING: 'text-red-600',
  PAID: 'text-green-600',
  DEBT: 'text-red-500',
  PAYMENT: 'text-green-500'
};
